import { Injectable, Inject } from '@angular/core';
import { Http, XHRBackend, RequestOptions, Request, RequestOptionsArgs, Response, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw'; //delete this

import { Config } from '../../../config';
import { DOCUMENT } from '@angular/common';

@Injectable()
export class HttpService extends Http {
  
  public redirectURL;

  constructor(backend: XHRBackend, options: RequestOptions) {
    options.headers.set('Content-Type', 'application/json');
    if (options.headers) {
      options.headers.delete('ApiSecret');
      options.headers.delete('apisecret');
    }
    super(backend, options);
  }

  request(url: string | Request, options?: RequestOptionsArgs): Observable<Response> {
    let config = new Config();
    let token = this.getCookie('token');
    let clientCode = this.getCookie('clientCode');
    let isPublic = false;
    if (typeof url === 'string') {
      if (/publicflow/i.test(url) || /ValidateCompanyToken/i.test(url)) {
        isPublic = true;
        url = url.replace(/publicflow\/?/ig, '');
      }
    } else if (url && (url as any).url) {
      if (/publicflow/i.test((url as any).url) || /ValidateCompanyToken/i.test((url as any).url)) {
        isPublic = true;
        (url as any).url = (url as any).url.replace(/publicflow\/?/ig, '');
      }
    }
    if (options && options.url && (/publicflow/i.test(options.url) || /ValidateCompanyToken/i.test(options.url))) {
      isPublic = true;
      options.url = options.url.replace(/publicflow\/?/ig, '');
    }

    this.stripSecretHeaders(typeof url === 'string' ? null : url, options);

    if (typeof url !== 'string' && url.headers && url.headers['lazyUpdate'] && url.headers['lazyUpdate'][1] && url.headers['lazyUpdate'][1].name == "Authorization" && !isPublic) {
    } else {
      if (typeof url === 'string') {
        if (!options) {
          options = { headers: new Headers() };
        }
        url = this.resolveAppointmentUrl(url, isPublic, config);
        if (isPublic) {
          this.stripAuthHeaders(options);
        } else {
          options.headers.set('JwtToken', `${token}`);
          options.headers.set('CompanyCode', `${clientCode}`);
          options.headers.set('Content-Type', 'application/json');
          this.stripBearerHeaders(options);
        }
      } else if (url.url.includes('accounts-api') || url.url.indexOf('/bff/accounts/') !== -1) {
        url.url = this.resolveAccountsUrl(url.url, config);
        url.headers.set('JwtToken', `${token}`);
        url.headers.set('CompanyCode', `${clientCode}`);
        url.headers.set('Content-Type', 'application/json');
        this.stripAuthHeadersFromRequest(url);
      } else {
        url.url = this.resolveAppointmentUrl(url.url, isPublic, config);
        if (isPublic) {
          this.stripAuthHeadersFromRequest(url);
        } else {
          url.headers.set('JwtToken', `${token}`);
          url.headers.set('CompanyCode', `${clientCode}`);
          url.headers.set('Content-Type', 'application/json');
          this.stripAuthHeadersFromRequest(url);
        }
      }
    }

    if (typeof url === 'string') {
      url = url.replace(/publicflow\/?/ig, '');
    } else if (url && (url as any).url) {
      (url as any).url = (url as any).url.replace(/publicflow\/?/ig, '');
    }
    if (options && options.url) {
      options.url = options.url.replace(/publicflow\/?/ig, '');
    }

    this.stripSecretHeaders(typeof url === 'string' ? null : url, options);

    return super.request(url, options).catch(this.catchAuthError(this, isPublic));
  }

  private resolveAppointmentUrl(requestUrl: string, isPublic: boolean, config: Config): string {
    if (!requestUrl) {
      return requestUrl;
    }
    if (requestUrl.indexOf('accounts-api') !== -1) {
      return isPublic ? requestUrl : this.resolveAccountsUrl(requestUrl, config);
    }
    if (requestUrl.indexOf('http://') === -1 && requestUrl.indexOf('https://') === -1) {
      return (isPublic ? config.apiUrl : config.bffApiUrl) + requestUrl;
    }
    if (!isPublic && requestUrl.indexOf('/api/bff/') === -1 && requestUrl.indexOf('/api/v1/') !== -1) {
      return requestUrl.replace('/api/v1/', '/api/bff/v1/');
    }
    return requestUrl;
  }

  private resolveAccountsUrl(requestUrl: string, config: Config): string {
    if (!requestUrl) {
      return requestUrl;
    }
    if (requestUrl.indexOf('/api/bff/accounts/') !== -1) {
      return requestUrl;
    }
    var marker = '/api/';
    var idx = requestUrl.toLowerCase().indexOf(marker);
    var path = idx >= 0 ? requestUrl.substring(idx + marker.length) : requestUrl.replace(/^https?:\/\/[^/]+\//, '');
    var bffRoot = config.bffApiUrl.replace(/\/v1\/?$/, '/');
    return bffRoot + 'accounts/' + path.replace(/^\//, '');
  }

  private stripBearerHeaders(options?: RequestOptionsArgs) {
    if (options && options.headers) {
      options.headers.delete('Authorization');
      options.headers.delete('authorization');
    }
  }

  private stripSecretHeaders(request?: Request, options?: RequestOptionsArgs) {
    if (request && request.headers) {
      request.headers.delete('ApiSecret');
      request.headers.delete('apisecret');
      request.headers.delete('Authorization');
      request.headers.delete('authorization');
    }
    if (options && options.headers) {
      options.headers.delete('ApiSecret');
      options.headers.delete('apisecret');
      options.headers.delete('Authorization');
      options.headers.delete('authorization');
    }
  }

  private stripAuthHeaders(options?: RequestOptionsArgs) {
    if (options && options.headers) {
      options.headers.delete('Authorization');
      options.headers.delete('authorization');
      options.headers.delete('ApiSecret');
      options.headers.delete('apisecret');
    }
  }

  private stripAuthHeadersFromRequest(request: Request) {
    if (request && request.headers) {
      request.headers.delete('Authorization');
      request.headers.delete('authorization');
      request.headers.delete('ApiSecret');
      request.headers.delete('apisecret');
    }
  }

  private catchAuthError(self: HttpService, isPublic?: boolean) {
    return (res: Response) => {
      if (!isPublic && (res.status === 401 || res.status === 403)) {
        // if not authenticated
        localStorage.clear();
        this.redirectURL = res.json().data;
        var baseURL = location.href.split('?');
        var companycode;
        let config = new Config();
        baseURL.forEach((url) => {
          if (url.match("companycode")) {
            companycode = url;
          }
        })
        if (companycode) {
          window.location.replace(
            config.loginUrl + "?returnUrl=" + baseURL[0] + "?" + companycode
          );
        } else {
          window.location.replace(
            config.loginUrl + "?returnUrl=" + baseURL[0]
          );
        }
        // window.location.replace(this.redirectURL + '?returnUrl=' + baseURL[0]);
        // console.log(res);
      }
      return Observable.throw(res);
    };
  }
  getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
  }
}

class getCookieToken{
  constructor( @Inject( DOCUMENT ) private document: any){}
     /**
   * @param name Cookie name
   * @returns {any}
   */
  getCookie( name: string ): string {
      name = encodeURIComponent( name );

      const regExp: RegExp = this.getCookieRegExp( name );
      const result: RegExpExecArray = regExp.exec( this.document.cookie );

      return decodeURIComponent( result[ 1 ] );
  }


 /**
   * @param name Cookie name
   * @returns {RegExp}
   */
  private getCookieRegExp( name: string ): RegExp {
    const escapedName: string = name.replace( /([\[\]\{\}\(\)\|\=\;\+\?\,\.\*\^\$])/ig, '\\$1' );

    return new RegExp( '(?:^' + escapedName + '|;\\s*' + escapedName + ')=(.*?)(?:;|$)', 'g' );
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/http.interceptor.service.ts